"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Dropdown_1 = require("../controls/Dropdown");
var Menu_1 = require("../Menu");
var CommandMenuButton_1 = require("./CommandMenuButton");
var helpers_1 = require("./helpers");
exports.useCommandMenu = function (_a) {
    var ref = _a.ref, className = _a.className, controlText = _a.controlText, controlIcon = _a.controlIcon, renderControl = _a.renderControl, menuItems = _a.items, disabled = _a.disabled, dropdownWidth = _a.dropdownWidth, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["ref", "className", "controlText", "controlIcon", "renderControl", "items", "disabled", "dropdownWidth", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var rootRef = react_1.useRef(null);
    var buttonRef = ref || rootRef;
    var menuItemsRef = react_1.useRef([]);
    return Dropdown_1.useDropdown({
        ref: buttonRef,
        getAdditionalContentNode: function () { return helpers_1.getAdditionalContentNode(menuItemsRef); },
        onDidHide: function () {
            menuItemsRef.current = [];
        },
        renderControl: function (renderControlProps) { var _a; return (_a = renderControl === null || renderControl === void 0 ? void 0 : renderControl(renderControlProps)) !== null && _a !== void 0 ? _a : (react_1.default.createElement(CommandMenuButton_1.CommandMenuButton, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'command-menu-button', className: "vm-CommandMenu " + className, icon: controlIcon, isActive: renderControlProps.isActive, disabled: disabled, onClick: onClick, onMouseDown: function (e) {
                renderControlProps.button.onMouseDown(e);
                onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(e);
            }, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: function (e) {
                onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
            }, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: renderControlProps.button.ref, style: style }), controlText)); },
        renderPopover: function (_a) {
            var popover = _a.popover, content = _a.content;
            menuItemsRef.current = [popover.ref];
            return react_1.default.createElement(Menu_1.Menu, __assign({}, popover), content);
        },
        renderContent: function (renderContentProps) { return (react_1.default.createElement(react_1.default.Fragment, null, helpers_1.getMenuItems({ menuItems: menuItems, renderContentProps: renderContentProps, menuItemsRef: menuItemsRef }))); },
        dropdownWidth: dropdownWidth
    });
};
//# sourceMappingURL=hooks.js.map